import { EWidget, TFilterSave, TFiltersWithType, TWidgetCustomParameters } from 'scw-digital-boards-widgets';

export enum EAdvancedFilterInputMode {
  submitButtonAndCancel = 'submitButtonAndCancel',
  autoSubmitWithCancel = 'autoSubmitWithCancel',
  autoSubmit = 'autoSubmit',
}

export type TModalConfiguration =
  | { fixedField?: string; initialField?: string; isEqAllowed: boolean; mode: EAdvancedFilterInputMode; type: 'add' }
  | {
      initialField?: never;
      fixedField?: string;
      initialValues: TFilterSave;
      isEqAllowed: boolean;
      mode: EAdvancedFilterInputMode;
      type: 'edit';
    };

export type TAdvancedFilterInputsAutoSubmit =
  | {
      isValid: false;
      data: null;
    }
  | { isValid: true; data: TFiltersWithType };

export interface IDataForWidgetSpecificConfiguration<Widget extends EWidget> {
  widgetType: Widget;
  typeBasedConfiguration: TWidgetCustomParameters[Widget];
  selectedFilterMode: string;
}
